import { render, staticRenderFns } from "./CollectionContentList.vue?vue&type=template&id=1a746fa0&scoped=true"
import script from "./CollectionContentList.vue?vue&type=script&lang=js"
export * from "./CollectionContentList.vue?vue&type=script&lang=js"
import style0 from "./CollectionContentList.vue?vue&type=style&index=0&id=1a746fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a746fa0",
  null
  
)

export default component.exports